import type {Schemas} from 'api/dto.generated';

const dto: Schemas.WorkFlattenedDto = {
  work: {
    id: '9bf89170-c7fa-4ea8-8be4-c83b378926bc',
    created: 1757597110247,
    modified: 1759491563972,
    type: 'BOOK',
    preferredTitle: ['Brand 3.0'],
    languages: ['nob'],
    agents: [
      {
        roles: ['A01'],
        agentId: '371bd9bf-badd-456a-bf6a-693ec7edfa1d',
        agentType: 'PERSON',
        agentName: {
          id: '99891b91-e35e-400e-b9c6-25d8a79c3339',
          name: 'Siri',
          surName: 'Løvaas',
          nameOrder: 0,
        },
        nationalId: '7040161',
      },
      {
        roles: ['A01'],
        agentId: '83bb61d1-6851-4c01-a745-d2fc2e7430ac',
        agentType: 'PERSON',
        agentName: {
          id: '5a6c9c7b-3f06-47e2-9365-4fe57c24589d',
          name: 'Arne Rusten',
          surName: 'Syltevig',
          nameOrder: 0,
        },
        nationalId: '90910410',
      },
    ],
    dewey: [
      {
        source: '15',
        value: '658.8',
      },
    ],
    literatureType: ['13'],
    themes: ['YPJV', '4CN', '4Z-NO-B'],
    grep: ['STSAM2----', 'SU', 'SAM3045', 'SAM3046'],
    genreAndForm: ['https://id.nb.no/vocabulary/ntsf/184'],
    educationTargetGroup: [],
    educationLevel: ['VG2', 'VG3'],
    teachingMaterials: ['6'],
    bibleContent: [],
    seriesRelations: [
      {
        entityId: 'ff9d2dd5-544c-40e8-a28c-1a0399bd30e7',
        role: 'PART_OF',
        type: 'SERIES',
        title: 'Økonomiske programfag',
        numberInSeries: undefined,
        allTitles: [
          {
            value: 'Økonomiske programfag',
            language: 'nob',
          },
        ],
      },
    ],
    workRelations: [],
    agentRelations: [],
    firstPublishedYear: 2025,
    prizes: [],
  },
  expressions: [
    {
      id: '359b2ea1-db73-4b24-9f88-838489d1978a',
      workId: '9bf89170-c7fa-4ea8-8be4-c83b378926bc',
      created: 1757597110247,
      modified: 1759491274498,
      expressionFormat: 'ILLUSTRATED_TEXT',
      languages: ['nob'],
      content: [],
      agents: [],
    },
  ],
  manifestations: [
    {
      id: 'bedc6acc-572f-4de3-a67c-bea6b6149147',
      expressionId: '359b2ea1-db73-4b24-9f88-838489d1978a',
      created: 1757597110234,
      modified: 1759491580985,
      registered: 1757597110234,
      status: 'COMPLETED',
      isbn: '9788211049766',
      ean: '9788211049766',
      wrongIsbn: [],
      edition: 1,
      publishedYear: 2025,
      pageCount: '71',
      contentReceivedDate: '2025-10-03',
      completedDate: '2025-10-03',
      productForm: 'BC',
      productFormDetail: [],
      physicalProperties: [],
      bookGroup: '120',
      productGroup: '12010',
      externalSystemInfo: {
        ids: [],
        created: undefined,
        modified: undefined,
      },
      titleInfo: {
        mainTitles: [
          {
            subTitles: [
              {
                parallelTitles: [],
                value: 'verktøymanual Markedsføring og ledelse',
                order: 0,
              },
            ],
            parallelTitles: [],
            value: 'Brand 3.0',
            order: 0,
          },
        ],
        otherTitles: [],
      },
      editionType: [],
      teachingMaterials: [],
      seriesRelations: [],
      imprints: [
        {
          agentId: '999384e4-d50f-4b8b-b3e2-07f1276981cd',
          agentName: {
            id: '3c4a824e-d954-4789-9a9d-8cb3055a2bba',
            name: 'Fagbokforlaget',
            nameOrder: 0,
          },
          place: 'Bergen',
        },
      ],
      productOwners: [
        {
          code: '0522',
          name: 'Vigmostad & Bjørke AS',
        },
      ],
      marketingData: {
        products: [
          {
            owner: '0522',
            distributor: 'FBF',
            status: 'ACTIVE',
            publisherSalesDate: '2025-09-11',
            inSaleDate: '2025-09-11',
            comingDate: undefined,
            measures: [
              {
                type: 'WEIGHT',
                value: '242',
                unit: 'GRAM',
              },
              {
                type: 'WIDTH',
                value: '205',
                unit: 'MM',
              },
              {
                type: 'THICKNESS',
                value: '5',
                unit: 'MM',
              },
              {
                type: 'HEIGHT',
                value: '288',
                unit: 'MM',
              },
            ],
            descriptions: [
              {
                content:
                  'Brand 3.0 er en verktøymanual med utspring fra læreverkene Brand 1.0 og Brand 2.0, for faget Markedsføring og ledelse.\n\nMed en samling av overordnede styringsverktøy, analyse- og planleggingsverktøy, åpner Brand 3.0 for en visuell oversikt over relevante verktøy som kan anvendes sammen og hver for seg, avhengig av formål.\n\nSom fundament, vil kunnskap om samfunnsansvar, lover, regler og etikk, bærekraft, digitalisering, ledelse og forbrukeratferd, komplementere anvendelsen av markedsføringsteorien gjennom verktøyene.\n\nBærekraft er i dag aktuelt gjennom hele verdikjeden. Den digitale revolusjonen åpner for utallige måter å både innhente, bearbeide og anvende informasjon på. Virksomheter som ledes gjennom en sunn kultur og struktur, og som åpner for kreativitet og innovasjon, kan oppnå uante konkurransefortrinn når ansatte får utfolde seg gjennom kombinasjoner og transformasjoner av kunnskap og markedsføringsverktøy.\n\nDrivkrefter utløser nye måter å produsere og forbruke på. Forbrukermekanismene endrer seg gjennom hele livsløpet og kundereisen er sentral når forbrukeren skal erfare riktig budskap til riktig tid. Nødvendigheten av positive og konsistente kundeopplevelser krever at virksomheter ligger i forkant når kunden skal velge fra et «hav av informasjon».\n\nBrand 3.0 er utviklet for å inspirere og motivere elever på videregående skole, studenter ved høyere utdanning og folk i arbeidslivet – til å nyttiggjøre seg mulighetene verktøyene gir, visuelt som teoretisk, slik at de en dag – kan berike andre med sine funn – som kan gjøre hverdagen til et enda bedre sted å være.',
                language: 'nor',
                agentId: undefined,
                type: 'PLAINTEXT',
              },
            ],
            hidden: false,
            publisherStatus: '04',
            distributorStatus: '21',
          },
        ],
      },
      statementOfResponsibility: 'Siri Løvaas & Arne Rusten Syltevig',
      autoGenerateStatementOfResponsibility: false,
      trykkunderlagData: {
        willNotBeDelivered: false,
      },
    },
  ],
};

export default dto;
